import { render, staticRenderFns } from "./DataDash.vue?vue&type=template&id=3e0764f4&scoped=true"
import script from "./DataDash.vue?vue&type=script&setup=true&lang=js"
export * from "./DataDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DataDash.vue?vue&type=style&index=0&id=3e0764f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0764f4",
  null
  
)

export default component.exports